export const DistFileMapping = {
    "Calamity-Regular.otf": "Calamity-Regular-TVtsC3YK.otf",
    "Obj_DLC_HeroSeal_Gerudo.png": "Obj_DLC_HeroSeal_Gerudo-S7sJl8Ib.png",
    "Obj_DLC_HeroSeal_Gerudo.webp": "Obj_DLC_HeroSeal_Gerudo-XufaEPhd.webp",
    "Obj_DLC_HeroSeal_Goron.png": "Obj_DLC_HeroSeal_Goron-HgR6v-bp.png",
    "Obj_DLC_HeroSeal_Goron.webp": "Obj_DLC_HeroSeal_Goron-DPmuCUhw.webp",
    "Obj_DLC_HeroSeal_Rito.png": "Obj_DLC_HeroSeal_Rito-qfG_uTkn.png",
    "Obj_DLC_HeroSeal_Rito.webp": "Obj_DLC_HeroSeal_Rito-bA7Awq_M.webp",
    "Obj_DLC_HeroSeal_Zora.png": "Obj_DLC_HeroSeal_Zora-8AKCEd1i.png",
    "Obj_DLC_HeroSeal_Zora.webp": "Obj_DLC_HeroSeal_Zora-MWaHuibR.webp",
    "Obj_DLC_HeroSoul_Gerudo.png": "Obj_DLC_HeroSoul_Gerudo-51M9YAi-.png",
    "Obj_DLC_HeroSoul_Gerudo.webp": "Obj_DLC_HeroSoul_Gerudo-s-wyOfZy.webp",
    "Obj_DLC_HeroSoul_Gerudo_Disabled.png": "Obj_DLC_HeroSoul_Gerudo_Disabled-Aw6M8h41.png",
    "Obj_DLC_HeroSoul_Gerudo_Disabled.webp": "Obj_DLC_HeroSoul_Gerudo_Disabled-caN0M5Zk.webp",
    "Obj_DLC_HeroSoul_Goron.png": "Obj_DLC_HeroSoul_Goron-xDtc5v1F.png",
    "Obj_DLC_HeroSoul_Goron.webp": "Obj_DLC_HeroSoul_Goron-2I_XwYrO.webp",
    "Obj_DLC_HeroSoul_Goron_Disabled.png": "Obj_DLC_HeroSoul_Goron_Disabled-P37fdJzB.png",
    "Obj_DLC_HeroSoul_Goron_Disabled.webp": "Obj_DLC_HeroSoul_Goron_Disabled-yZ8fbEF2.webp",
    "Obj_DLC_HeroSoul_Rito.png": "Obj_DLC_HeroSoul_Rito-OIpVLnHP.png",
    "Obj_DLC_HeroSoul_Rito.webp": "Obj_DLC_HeroSoul_Rito-CtZrC_lW.webp",
    "Obj_DLC_HeroSoul_Rito_Disabled.png": "Obj_DLC_HeroSoul_Rito_Disabled-CjUKLOjk.png",
    "Obj_DLC_HeroSoul_Rito_Disabled.webp": "Obj_DLC_HeroSoul_Rito_Disabled-eirZGOe_.webp",
    "Obj_DLC_HeroSoul_Zora.png": "Obj_DLC_HeroSoul_Zora-qRWr4Mai.png",
    "Obj_DLC_HeroSoul_Zora.webp": "Obj_DLC_HeroSoul_Zora-KIk0qDRG.webp",
    "Obj_DLC_HeroSoul_Zora_Disabled.png": "Obj_DLC_HeroSoul_Zora_Disabled-Fu22ieUj.png",
    "Obj_DLC_HeroSoul_Zora_Disabled.webp": "Obj_DLC_HeroSoul_Zora_Disabled-jgF3FX6z.webp",
    "Obj_DungeonClearSeal.png": "Obj_DungeonClearSeal-AMjmZKe5.png",
    "Obj_DungeonClearSeal.webp": "Obj_DungeonClearSeal-gGS-XDIA.webp",
    "Obj_HeroSoul_Gerudo.png": "Obj_HeroSoul_Gerudo-64tIMmfF.png",
    "Obj_HeroSoul_Gerudo.webp": "Obj_HeroSoul_Gerudo-tPSVNK00.webp",
    "Obj_HeroSoul_Gerudo_Disabled.png": "Obj_HeroSoul_Gerudo_Disabled-aPqiky72.png",
    "Obj_HeroSoul_Gerudo_Disabled.webp": "Obj_HeroSoul_Gerudo_Disabled-wNpPGggb.webp",
    "Obj_HeroSoul_Goron.png": "Obj_HeroSoul_Goron-Y3LhJse7.png",
    "Obj_HeroSoul_Goron.webp": "Obj_HeroSoul_Goron-hz0Ot8R2.webp",
    "Obj_HeroSoul_Goron_Disabled.png": "Obj_HeroSoul_Goron_Disabled-l0_kPYDh.png",
    "Obj_HeroSoul_Goron_Disabled.webp": "Obj_HeroSoul_Goron_Disabled-s26XYXEa.webp",
    "Obj_HeroSoul_Rito.png": "Obj_HeroSoul_Rito-Sgk7JcNC.png",
    "Obj_HeroSoul_Rito.webp": "Obj_HeroSoul_Rito-swC4CSUO.webp",
    "Obj_HeroSoul_Rito_Disabled.png": "Obj_HeroSoul_Rito_Disabled-9FxE6fvK.png",
    "Obj_HeroSoul_Rito_Disabled.webp": "Obj_HeroSoul_Rito_Disabled-3ViR1QrR.webp",
    "Obj_HeroSoul_Zora.png": "Obj_HeroSoul_Zora-a5JM_YVj.png",
    "Obj_HeroSoul_Zora.webp": "Obj_HeroSoul_Zora-L3iGJk0I.webp",
    "Obj_HeroSoul_Zora_Disabled.png": "Obj_HeroSoul_Zora_Disabled-gbe1lQaS.png",
    "Obj_HeroSoul_Zora_Disabled.webp": "Obj_HeroSoul_Zora_Disabled-5hqtKIDn.webp",
    "Obj_WarpDLC.png": "Obj_WarpDLC-zGRy1ZGe.png",
    "Obj_WarpDLC.webp": "Obj_WarpDLC-rAGGBYxu.webp",
    "SheikahBackground.png": "SheikahBackground-Dpizl8g7.png",
    "SheikahBackgroundLight.png": "SheikahBackgroundLight-9VwOTTry.png",
    "bg-gerudo.jpg": "bg-gerudo-Djuc_l4k.jpg",
    "bg-goron.jpg": "bg-goron-qvPTf2X4.jpg",
    "bg-hateno.jpg": "bg-hateno-WyniMYJu.jpg",
    "bg-kakariko.jpg": "bg-kakariko-MLK3-n2_.jpg",
    "bg-korok-forest.jpg": "bg-korok-forest-wX1_53si.jpg",
    "bg-plateau.jpg": "bg-plateau-sBBYGR_f.jpg",
    "bg-rito.jpg": "bg-rito-r43AWgxd.jpg",
    "bg-sor.jpg": "bg-sor-AvTp1dID.jpg",
    "bg-zora.jpg": "bg-zora-7fWPIt2w.jpg",
    "chunk0x32.webp": "chunk0x32-Q9OXn-cd.webp",
    "chunk0x64.webp": "chunk0x64-yQniHrpa.webp",
    "chunk1x32.webp": "chunk1x32-8Qk3cffT.webp",
    "chunk1x64.webp": "chunk1x64-Git30dSw.webp",
    "chunk2x32.webp": "chunk2x32-Ipz0lLlN.webp",
    "chunk2x64.webp": "chunk2x64-QNEnm2GE.webp",
    "modifiers.webp": "modifiers-G8iZrxY8.webp",
} as const;
export type DistFileKey = keyof typeof DistFileMapping;

